<div class="success">
  <h1>Email has already been verified!</h1>
  <h3>Please <a href="/login">Login</a></h3>
</div>
